import ServerBaseError from './ServerBaseError';

export default class RequestRetryError extends ServerBaseError {
  constructor(message = 'Retried requests failed', showErrorPage = false) {
    super(message, showErrorPage);
  }
}
